import { render, staticRenderFns } from "./infoZh.vue?vue&type=template&id=6221bb00&scoped=true"
import script from "./infoZh.vue?vue&type=script&lang=js"
export * from "./infoZh.vue?vue&type=script&lang=js"
import style0 from "./infoZh.vue?vue&type=style&index=0&id=6221bb00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6221bb00",
  null
  
)

export default component.exports